{
	"v": "5.5.1",
	"fr": 60,
	"ip": 0,
	"op": 180,
	"w": 150,
	"h": 150,
	"nm": "Rocket Icon",
	"ddd": 0,
	"assets": [],
	"layers": [
		{
			"ddd": 0,
			"ind": 1,
			"ty": 4,
			"nm": "Rocket Icon Outlines",
			"sr": 1,
			"ks": {
				"o": { "a": 0, "k": 100, "ix": 11 },
				"r": { "a": 0, "k": 0, "ix": 10 },
				"p": {
					"a": 1,
					"k": [
						{
							"i": { "x": 0.833, "y": 1 },
							"o": { "x": 0.167, "y": 0 },
							"t": 0,
							"s": [75, 208, 0],
							"to": null,
							"ti": null
						},
						{ "t": 62, "s": [75, 75, 0] }
					],
					"ix": 2
				},
				"a": { "a": 0, "k": [73.009, 76.964, 0], "ix": 1 },
				"s": { "a": 0, "k": [100, 100, 100], "ix": 6 }
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[65.894, 121.265],
										[65.894, 130.752]
									],
									"o": [
										[65.894, 121.265],
										[65.894, 130.752]
									],
									"v": [
										[65.894, 121.265],
										[65.894, 130.752]
									],
									"c": false
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false,
							"_render": true
						},
						{
							"ty": "st",
							"c": { "a": 0, "k": [0.5019607843137255, 0.4196078431372549, 0.615686274509804, 1], "ix": 3 },
							"o": { "a": 0, "k": 100, "ix": 4 },
							"w": { "a": 0, "k": 2, "ix": 5 },
							"lc": 2,
							"lj": 2,
							"bm": 0,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false,
							"_render": true
						},
						{
							"ty": "tr",
							"p": { "a": 0, "k": [0, 0], "ix": 2 },
							"a": { "a": 0, "k": [0, 0], "ix": 1 },
							"s": { "a": 0, "k": [100, 100], "ix": 3 },
							"r": { "a": 0, "k": 0, "ix": 6 },
							"o": { "a": 0, "k": 100, "ix": 7 },
							"sk": { "a": 0, "k": 0, "ix": 4 },
							"sa": { "a": 0, "k": 0, "ix": 5 },
							"nm": "Transform",
							"_render": true
						}
					],
					"nm": "Group 1",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false,
					"_render": true
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[65.894, 113.408],
										[65.894, 115.998]
									],
									"o": [
										[65.894, 113.408],
										[65.894, 115.998]
									],
									"v": [
										[65.894, 113.408],
										[65.894, 115.998]
									],
									"c": false
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false,
							"_render": true
						},
						{
							"ty": "st",
							"c": { "a": 0, "k": [0.5019607843137255, 0.4196078431372549, 0.615686274509804, 1], "ix": 3 },
							"o": { "a": 0, "k": 100, "ix": 4 },
							"w": { "a": 0, "k": 2, "ix": 5 },
							"lc": 2,
							"lj": 2,
							"bm": 0,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false,
							"_render": true
						},
						{
							"ty": "tr",
							"p": { "a": 0, "k": [0, 0], "ix": 2 },
							"a": { "a": 0, "k": [0, 0], "ix": 1 },
							"s": { "a": 0, "k": [100, 100], "ix": 3 },
							"r": { "a": 0, "k": 0, "ix": 6 },
							"o": { "a": 0, "k": 100, "ix": 7 },
							"sk": { "a": 0, "k": 0, "ix": 4 },
							"sa": { "a": 0, "k": 0, "ix": 5 },
							"nm": "Transform",
							"_render": true
						}
					],
					"nm": "Group 2",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 2,
					"mn": "ADBE Vector Group",
					"hd": false,
					"_render": true
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[80.101, 126.003],
										[80.101, 130.752]
									],
									"o": [
										[80.101, 126.003],
										[80.101, 130.752]
									],
									"v": [
										[80.101, 126.003],
										[80.101, 130.752]
									],
									"c": false
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false,
							"_render": true
						},
						{
							"ty": "st",
							"c": { "a": 0, "k": [0.5019607843137255, 0.4196078431372549, 0.615686274509804, 1], "ix": 3 },
							"o": { "a": 0, "k": 100, "ix": 4 },
							"w": { "a": 0, "k": 2, "ix": 5 },
							"lc": 2,
							"lj": 2,
							"bm": 0,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false,
							"_render": true
						},
						{
							"ty": "tr",
							"p": { "a": 0, "k": [0, 0], "ix": 2 },
							"a": { "a": 0, "k": [0, 0], "ix": 1 },
							"s": { "a": 0, "k": [100, 100], "ix": 3 },
							"r": { "a": 0, "k": 0, "ix": 6 },
							"o": { "a": 0, "k": 100, "ix": 7 },
							"sk": { "a": 0, "k": 0, "ix": 4 },
							"sa": { "a": 0, "k": 0, "ix": 5 },
							"nm": "Transform",
							"_render": true
						}
					],
					"nm": "Group 3",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 3,
					"mn": "ADBE Vector Group",
					"hd": false,
					"_render": true
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[80.101, 113.408],
										[80.101, 121.07]
									],
									"o": [
										[80.101, 113.408],
										[80.101, 121.07]
									],
									"v": [
										[80.101, 113.408],
										[80.101, 121.07]
									],
									"c": false
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false,
							"_render": true
						},
						{
							"ty": "st",
							"c": { "a": 0, "k": [0.5019607843137255, 0.4196078431372549, 0.615686274509804, 1], "ix": 3 },
							"o": { "a": 0, "k": 100, "ix": 4 },
							"w": { "a": 0, "k": 2, "ix": 5 },
							"lc": 2,
							"lj": 2,
							"bm": 0,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false,
							"_render": true
						},
						{
							"ty": "tr",
							"p": { "a": 0, "k": [0, 0], "ix": 2 },
							"a": { "a": 0, "k": [0, 0], "ix": 1 },
							"s": { "a": 0, "k": [100, 100], "ix": 3 },
							"r": { "a": 0, "k": 0, "ix": 6 },
							"o": { "a": 0, "k": 100, "ix": 7 },
							"sk": { "a": 0, "k": 0, "ix": 4 },
							"sa": { "a": 0, "k": 0, "ix": 5 },
							"nm": "Transform",
							"_render": true
						}
					],
					"nm": "Group 4",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 4,
					"mn": "ADBE Vector Group",
					"hd": false,
					"_render": true
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[73, 113.408],
										[73, 130.752]
									],
									"o": [
										[73, 113.408],
										[73, 130.752]
									],
									"v": [
										[73, 113.408],
										[73, 130.752]
									],
									"c": false
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false,
							"_render": true
						},
						{
							"ty": "st",
							"c": { "a": 0, "k": [0.5019607843137255, 0.4196078431372549, 0.615686274509804, 1], "ix": 3 },
							"o": { "a": 0, "k": 100, "ix": 4 },
							"w": { "a": 0, "k": 2, "ix": 5 },
							"lc": 2,
							"lj": 2,
							"bm": 0,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false,
							"_render": true
						},
						{
							"ty": "tr",
							"p": { "a": 0, "k": [0, 0], "ix": 2 },
							"a": { "a": 0, "k": [0, 0], "ix": 1 },
							"s": { "a": 0, "k": [100, 100], "ix": 3 },
							"r": { "a": 0, "k": 0, "ix": 6 },
							"o": { "a": 0, "k": 100, "ix": 7 },
							"sk": { "a": 0, "k": 0, "ix": 4 },
							"sa": { "a": 0, "k": 0, "ix": 5 },
							"nm": "Transform",
							"_render": true
						}
					],
					"nm": "Group 5",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 5,
					"mn": "ADBE Vector Group",
					"hd": false,
					"_render": true
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[-9.145, -4.436],
										[-11.047, 4.436],
										[11.046, 4.436],
										[9.117, -4.436]
									],
									"o": [
										[-9.145, -4.436],
										[-11.047, 4.436],
										[11.046, 4.436],
										[9.117, -4.436]
									],
									"v": [
										[-9.145, -4.436],
										[-11.047, 4.436],
										[11.046, 4.436],
										[9.117, -4.436]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false,
							"_render": true
						},
						{
							"ty": "st",
							"c": { "a": 0, "k": [0.5019607843137255, 0.4196078431372549, 0.615686274509804, 1], "ix": 3 },
							"o": { "a": 0, "k": 100, "ix": 4 },
							"w": { "a": 0, "k": 2, "ix": 5 },
							"lc": 2,
							"lj": 2,
							"bm": 0,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false,
							"_render": true
						},
						{
							"ty": "tr",
							"p": { "a": 0, "k": [73, 102.193], "ix": 2 },
							"a": { "a": 0, "k": [0, 0], "ix": 1 },
							"s": { "a": 0, "k": [100, 100], "ix": 3 },
							"r": { "a": 0, "k": 0, "ix": 6 },
							"o": { "a": 0, "k": 100, "ix": 7 },
							"sk": { "a": 0, "k": 0, "ix": 4 },
							"sa": { "a": 0, "k": 0, "ix": 5 },
							"nm": "Transform",
							"_render": true
						}
					],
					"nm": "Group 6",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 6,
					"mn": "ADBE Vector Group",
					"hd": false,
					"_render": true
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[-5.74, -16.363],
										[5.74, -3.865],
										[5.518, 16.363],
										[-5.636, 7.142]
									],
									"o": [
										[-5.74, -16.363],
										[5.74, -3.865],
										[5.518, 16.363],
										[-5.636, 7.142]
									],
									"v": [
										[-5.74, -16.363],
										[5.74, -3.865],
										[5.518, 16.363],
										[-5.636, 7.142]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false,
							"_render": true
						},
						{
							"ty": "st",
							"c": { "a": 0, "k": [0.5019607843137255, 0.4196078431372549, 0.615686274509804, 1], "ix": 3 },
							"o": { "a": 0, "k": 100, "ix": 4 },
							"w": { "a": 0, "k": 2, "ix": 5 },
							"lc": 2,
							"lj": 2,
							"bm": 0,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false,
							"_render": true
						},
						{
							"ty": "tr",
							"p": { "a": 0, "k": [99.503, 90.266], "ix": 2 },
							"a": { "a": 0, "k": [0, 0], "ix": 1 },
							"s": { "a": 0, "k": [100, 100], "ix": 3 },
							"r": { "a": 0, "k": 0, "ix": 6 },
							"o": { "a": 0, "k": 100, "ix": 7 },
							"sk": { "a": 0, "k": 0, "ix": 4 },
							"sa": { "a": 0, "k": 0, "ix": 5 },
							"nm": "Transform",
							"_render": true
						}
					],
					"nm": "Group 7",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 7,
					"mn": "ADBE Vector Group",
					"hd": false,
					"_render": true
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[5.739, -16.363],
										[-5.55, -4.107],
										[-5.739, -3.7569999999999997],
										[-5.519, 16.363],
										[5.635, 7.142]
									],
									"o": [
										[5.739, -16.363],
										[-5.673, -3.95],
										[-5.737, -3.558],
										[-5.519, 16.363],
										[5.635, 7.142]
									],
									"v": [
										[5.739, -16.363],
										[-5.55, -4.107],
										[-5.737, -3.558],
										[-5.519, 16.363],
										[5.635, 7.142]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false,
							"_render": true
						},
						{
							"ty": "st",
							"c": { "a": 0, "k": [0.5019607843137255, 0.4196078431372549, 0.615686274509804, 1], "ix": 3 },
							"o": { "a": 0, "k": 100, "ix": 4 },
							"w": { "a": 0, "k": 2, "ix": 5 },
							"lc": 2,
							"lj": 2,
							"bm": 0,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false,
							"_render": true
						},
						{
							"ty": "tr",
							"p": { "a": 0, "k": [46.512, 90.266], "ix": 2 },
							"a": { "a": 0, "k": [0, 0], "ix": 1 },
							"s": { "a": 0, "k": [100, 100], "ix": 3 },
							"r": { "a": 0, "k": 0, "ix": 6 },
							"o": { "a": 0, "k": 100, "ix": 7 },
							"sk": { "a": 0, "k": 0, "ix": 4 },
							"sa": { "a": 0, "k": 0, "ix": 5 },
							"nm": "Transform",
							"_render": true
						}
					],
					"nm": "Group 8",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 8,
					"mn": "ADBE Vector Group",
					"hd": false,
					"_render": true
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[7.143, -3.945],
										[3.944, 7.143],
										[-7.143, 3.945],
										[-3.945, -7.143]
									],
									"o": [
										[7.143, 3.945],
										[-3.945, 7.143],
										[-7.143, -3.945],
										[3.944, -7.143]
									],
									"v": [
										[7.143, 0],
										[-0.001, 7.143],
										[-7.143, 0],
										[-0.001, -7.143]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false,
							"_render": true
						},
						{
							"ty": "st",
							"c": { "a": 0, "k": [0.5019607843137255, 0.4196078431372549, 0.615686274509804, 1], "ix": 3 },
							"o": { "a": 0, "k": 100, "ix": 4 },
							"w": { "a": 0, "k": 2, "ix": 5 },
							"lc": 2,
							"lj": 2,
							"bm": 0,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false,
							"_render": true
						},
						{
							"ty": "tr",
							"p": { "a": 0, "k": [73, 60], "ix": 2 },
							"a": { "a": 0, "k": [0, 0], "ix": 1 },
							"s": { "a": 0, "k": [100, 100], "ix": 3 },
							"r": { "a": 0, "k": 0, "ix": 6 },
							"o": { "a": 0, "k": 100, "ix": 7 },
							"sk": { "a": 0, "k": 0, "ix": 4 },
							"sa": { "a": 0, "k": 0, "ix": 5 },
							"nm": "Transform",
							"_render": true
						}
					],
					"nm": "Group 9",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 9,
					"mn": "ADBE Vector Group",
					"hd": false,
					"_render": true
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[-14.568, -2.49],
										[-8.609, 2.49],
										[14.568, -2.49]
									],
									"o": [
										[-14.568, -2.49],
										[8.482999999999999, 2.49],
										[14.568, -2.49]
									],
									"v": [
										[-14.568, -2.49],
										[-0.063, 2.49],
										[14.568, -2.49]
									],
									"c": false
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false,
							"_render": true
						},
						{
							"ty": "st",
							"c": { "a": 0, "k": [0.5019607843137255, 0.4196078431372549, 0.615686274509804, 1], "ix": 3 },
							"o": { "a": 0, "k": 100, "ix": 4 },
							"w": { "a": 0, "k": 1.5, "ix": 5 },
							"lc": 2,
							"lj": 2,
							"bm": 0,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false,
							"_render": true
						},
						{
							"ty": "tr",
							"p": { "a": 0, "k": [72.791, 43.758], "ix": 2 },
							"a": { "a": 0, "k": [0, 0], "ix": 1 },
							"s": { "a": 0, "k": [100, 100], "ix": 3 },
							"r": { "a": 0, "k": 0, "ix": 6 },
							"o": { "a": 0, "k": 100, "ix": 7 },
							"sk": { "a": 0, "k": 0, "ix": 4 },
							"sa": { "a": 0, "k": 0, "ix": 5 },
							"nm": "Transform",
							"_render": true
						}
					],
					"nm": "Group 10",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 10,
					"mn": "ADBE Vector Group",
					"hd": false,
					"_render": true
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[-20.764, 37.292],
										[20.764, 37.292],
										[20.764, 2.758],
										[19.639999999999997, -21.905],
										[-20.764, -23.361]
									],
									"o": [
										[-20.764, 37.292],
										[20.764, 37.292],
										[20.764, 2.758],
										[-0.001, -37.292],
										[-20.764, 2.758]
									],
									"v": [
										[-20.764, 37.292],
										[20.764, 37.292],
										[20.764, 2.758],
										[-0.001, -37.292],
										[-20.764, 2.758]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false,
							"_render": true
						},
						{
							"ty": "st",
							"c": { "a": 0, "k": [0.5019607843137255, 0.4196078431372549, 0.615686274509804, 1], "ix": 3 },
							"o": { "a": 0, "k": 100, "ix": 4 },
							"w": { "a": 0, "k": 2, "ix": 5 },
							"lc": 2,
							"lj": 2,
							"bm": 0,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false,
							"_render": true
						},
						{
							"ty": "tr",
							"p": { "a": 0, "k": [73, 60.466], "ix": 2 },
							"a": { "a": 0, "k": [0, 0], "ix": 1 },
							"s": { "a": 0, "k": [100, 100], "ix": 3 },
							"r": { "a": 0, "k": 0, "ix": 6 },
							"o": { "a": 0, "k": 100, "ix": 7 },
							"sk": { "a": 0, "k": 0, "ix": 4 },
							"sa": { "a": 0, "k": 0, "ix": 5 },
							"nm": "Transform",
							"_render": true
						}
					],
					"nm": "Group 11",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 11,
					"mn": "ADBE Vector Group",
					"hd": false,
					"_render": true
				}
			],
			"ip": 0,
			"op": 7200,
			"st": 0,
			"bm": 0,
			"completed": true
		}
	],
	"markers": [],
	"__complete": true
}
